import { Reveal } from "@/components/Reveal";
import { STEPS } from "@/lib/site";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process"
      className="relative py-24 lg:py-32 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="rsm-eyebrow mb-5">How We Work</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white max-w-2xl leading-[1.1]">
            Four steps from first touch to booked call.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {STEPS.map((s, i) => (
            <Reveal key={s.step} delay={i * 0.1}>
              <div
                data-testid={`process-step-${s.step}`}
                className="group h-full bg-[#0a0d14] p-8 lg:p-9 transition-colors hover:bg-[#121927]"
              >
                <div className="font-display text-5xl font-extrabold text-white/10 transition-colors group-hover:text-amber-400/30">
                  {s.step}
                </div>
                <h3 className="mt-6 font-display text-lg font-bold text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">
                  {s.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
